import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col-12 p-0" }
const _hoisted_2 = { class: "card p-0 bg-white border-radius-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-white border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-block text-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey m-0" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Portfolio")
    ])
  ])
], -1)
const _hoisted_4 = { class: "row my-3 justify-content-center" }
const _hoisted_5 = { class: "col-md-12 px-4 py-2" }
const _hoisted_6 = { class: "card p-2 bg-card-grey border-radius-10" }
const _hoisted_7 = { class: "row mt-3 mx-1" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-control bg-white d-flex justify-content-between p-3" }
const _hoisted_10 = { class: "width-110 font-grey font-size-12" }
const _hoisted_11 = { class: "font-grey font-size-12" }
const _hoisted_12 = { class: "font-grey font-size-12" }
const _hoisted_13 = { class: "col-md-12 p-0" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  class: "form-control d-flex justify-content-between p-3",
  style: {"background":"#6F7F9B!important"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", { class: "width-110 font-white font-size-12" }, "Total", -1)
const _hoisted_17 = { class: "font-white font-size-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-12 p-0",
                  key: ac.userac_id
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("b", _hoisted_10, _toDisplayString(ac.ac_name), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(ac.ac_percent.toFixed()) + " % ", 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.total_active_default_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}